<script setup lang="ts">
import { computed } from 'vue';
import { BToast } from 'bootstrap-vue-next';
import type { Toast } from './useToast';

const props = defineProps<{ toast: Toast }>();
const emit = defineEmits<{ close: [] }>();

const variantIcon = computed(() => {
  switch (props.toast.variant) {
    case 'success':
      return 'mdi:check-circle';
    case 'danger':
      return 'mdi:alert-circle';
    case 'warning':
      return 'mdi:alert';
    case 'info':
      return 'mdi:information';
    default:
      return 'mdi:bell';
  }
});

function handleHide() {
  emit('close');
}
</script>

<template>
  <BToast
    :model-value="true"
    :title="toast.title || undefined"
    :variant="toast.variant"
    :no-close-button="!toast.closable"
    :auto-hide-delay="0"
    class="mb-2"
    @hide="handleHide"
    @hidden="handleHide"
  >
    <div class="d-flex align-items-start">
      <iconify-icon
        v-if="!toast.title"
        :icon="variantIcon"
        class="me-2 mt-1 flex-shrink-0"
        style="font-size: 1.25rem"
      />
      <div v-if="toast.html" class="flex-grow-1" v-html="toast.message" />
      <div v-else class="flex-grow-1">{{ toast.message }}</div>
    </div>
  </BToast>
</template>

<style scoped>
:deep(.toast) {
  min-width: 250px;
  max-width: 350px;
}
</style>
